/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const reviewerDailyRowSchema = z.object({
  date: z.string(),
  approved: z.number(),
  rejected: z.number(),
  avgDecisionMs: z.number().nullable(),
  totalDecisionMs: z.number().nullable(),
  uncountedGaps: z.number().default(0),
  payableMs: z.number().default(0),
  approvedClips: z.number().default(0),
  rejectedClips: z.number().default(0),
});

export const reviewerPerformanceDailyV1DataSchema = z.object({
  userId: z.string(),
  rows: z.array(reviewerDailyRowSchema),
  allTimeDecisionMs: z.number(),
  totals: z.object({
    approved: z.number(),
    rejected: z.number(),
    total: z.number(),
    approvalRate: z.number().nullable(),
    avgDecisionMs: z.number().nullable(),
    totalDecisionMs: z.number(),
    uncountedGaps: z.number().default(0),
    payableMs: z.number().default(0),
    avgPayableMsPerDay: z.number().nullable().default(null),
    approvedClips: z.number().default(0),
    rejectedClips: z.number().default(0),
  }),
});

export type IReviewerDailyRow = z.infer<typeof reviewerDailyRowSchema>;
export type IReviewerPerformanceDailyV1Data = z.infer<typeof reviewerPerformanceDailyV1DataSchema>;

export const getReviewerPerformanceDailyV1ResponseSchema = createApiResponseSchema(
  reviewerPerformanceDailyV1DataSchema,
) as z.ZodSchema<IAPI<IReviewerPerformanceDailyV1Data>>;

export type IGetReviewerPerformanceDailyV1Response = IAPI<IReviewerPerformanceDailyV1Data>;
